"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AccordionSection.default;
  }
});

var _AccordionSection = _interopRequireDefault(require("./AccordionSection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }